import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.array.includes";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { USER_AUTH, SYS_BUTTON_AUTH } from '@/store/mutation-types';
var hasPermission = {
  install: function install(Vue, options) {
    Vue.directive('has', {
      inserted: function inserted(el, binding, vnode) {
        //节点权限处理，如果命中则不进行全局权限处理
        // if (!filterNodePermission(el, binding, vnode)) {
        var permissionLists = binding.value.split(',');
        var state = false;
        permissionLists.forEach(function (item) {
          state = state || filterGlobalPermission(el, {
            value: item
          }, vnode);
        });

        if (!state) {
          el.parentNode.removeChild(el);
        } // }

      }
    });
  }
};
/**
 * 全局权限控制
 */

export function filterNodePermission(el, binding, vnode) {
  var permissionList = [];

  try {
    var obj = vnode.context.$props.formData;

    if (obj) {
      var bpmList = obj.permissionList;

      var _iterator = _createForOfIteratorHelper(bpmList),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var bpm = _step.value;

          if (bpm.type != '2') {
            permissionList.push(bpm);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  } catch (e) {}

  if (permissionList === null || permissionList === '' || permissionList === undefined || permissionList.length <= 0) {
    //el.parentNode.removeChild(el)
    return false;
  }

  var permissions = [];

  for (var _i = 0, _permissionList = permissionList; _i < _permissionList.length; _i++) {
    var item = _permissionList[_i];

    if (item.type != '2') {
      permissions.push(item.action);
    }
  }

  if (!permissions.includes(binding.value)) {
    //el.parentNode.removeChild(el)
    return false;
  } else {
    var _iterator2 = _createForOfIteratorHelper(permissionList),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var item2 = _step2.value;

        if (binding.value === item2.action) {
          return true;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return false;
}
/**
 * 全局权限控制
 */

export function filterGlobalPermission(el, binding, vnode) {
  getBindingValue(binding, binding.value);
  var permissionList = [];
  var allPermissionList = []; //let authList = Vue.ls.get(USER_AUTH);

  var authList = JSON.parse(sessionStorage.getItem(USER_AUTH) || '[]');

  var _iterator3 = _createForOfIteratorHelper(authList),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var auth = _step3.value;

      if (auth.type != '2') {
        permissionList.push(auth);
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  var allAuthList = JSON.parse(sessionStorage.getItem(SYS_BUTTON_AUTH) || '[]');

  var _iterator4 = _createForOfIteratorHelper(allAuthList),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var gauth = _step4.value;

      if (gauth.type != '2') {
        allPermissionList.push(gauth);
      }
    } //设置全局配置是否有命中

  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  var invalidFlag = false; //无效命中

  if (allPermissionList != null && allPermissionList != '' && allPermissionList != undefined && allPermissionList.length > 0) {
    var _iterator5 = _createForOfIteratorHelper(allPermissionList),
        _step5;

    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var itemG = _step5.value;

        if (binding.value === itemG.action) {
          if (itemG.status == '0') {
            invalidFlag = true;
            break;
          }
        }
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  }

  if (invalidFlag) {
    return false;
  }

  if (permissionList === null || permissionList === '' || permissionList === undefined || permissionList.length <= 0) {
    return false;
  }

  var permissions = [];

  for (var _i2 = 0, _permissionList2 = permissionList; _i2 < _permissionList2.length; _i2++) {
    var item = _permissionList2[_i2];

    if (item.type != '2') {
      permissions.push(item.action);
    }
  } // 先从按钮的用户已授权按钮权限的缓存中找出最高权限
  // 没额外配置参数的权限高于有配置了额外参数的权限


  var largePermission = getLargePermission(binding); // 用最高权限的按钮进行额外参数的判断

  getBindingValue(binding, largePermission);
  console.log('binding', binding);
  console.log('largePermission', largePermission);

  if (largePermission) {
    return setBindingConditionExternal(binding);
  } else {
    return false;
  }
} // 先从按钮的用户已授权按钮权限的缓存中找出最高权限
// 没额外配置参数的权限高于有配置了额外参数的权限

export function getLargePermission(binding) {
  var authList = JSON.parse(sessionStorage.getItem(USER_AUTH) || '[]');
  var permissions = [];

  var _iterator6 = _createForOfIteratorHelper(authList),
      _step6;

  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var auth = _step6.value;

      if (auth.type != '2') {
        permissions.push(auth.action);
      }
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }

  var largePermission = null;

  for (var _i3 = 0, _permissions = permissions; _i3 < _permissions.length; _i3++) {
    var item = _permissions[_i3];

    if (item.split(';')[0] == binding.value) {
      if (item == binding.value) {
        largePermission = item;
      } else {
        if (largePermission == null) {
          largePermission = item;
        }
      }
    }
  }

  return largePermission;
} // 额外控制的因子再新增对应字段的数据到binding的对象中

export function getBindingValue(binding, bindingData) {
  if (!bindingData) return; // 页面上添加的额外参数

  if (bindingData.split('&&').length > 1) {
    for (var i = 1; i < bindingData.split('&&').length; i++) {
      var externalData = bindingData.split('&&')[i].split('=');
      binding[externalData[0]] = externalData[1];
    }

    binding.value = bindingData.split('&&')[0];
  } // 菜单配置项中的额外参数


  if (bindingData.split(';').length > 1) {
    for (var _i4 = 1; _i4 < bindingData.split(';').length; _i4++) {
      var _externalData = bindingData.split(';')[_i4].split('=');

      binding[_externalData[0]] = _externalData[1];
    }
  }
} // 设置额外的判断

export function setBindingConditionExternal(binding) {
  var state = true;

  if (binding.hasOwnProperty('delayTime')) {
    var delayTime = binding.delayTime ? binding.delayTime - 0 : 1000 * 60 * 60 * 24;
    var handleTime = binding.handleTime;

    if (new Date().getTime() - new Date(handleTime).getTime() > delayTime) {
      state = false;
    }
  }

  return state;
}
export default hasPermission;